'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultVideoThumbnail = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var DefaultVideoThumbnail = function DefaultVideoThumbnail(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === undefined ? 50 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 50 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#B7B9BC' : _ref$color,
      props = _objectWithoutProperties(_ref, ['width', 'height', 'color']);

  return _react2.default.createElement('svg', _extends({
    viewBox: '0 0 50 50',
    width: width,
    height: height
  }, props), _react2.default.createElement('path', {
    d: 'M23.34 2.33a.78.78 0 0 0-.78.06l-5.81 4.15V3A2.75 2.75 0 0 0 14 .25H3A2.75 2.75 0 0 0 .25 3v10A2.75 2.75 0 0 0 3 15.75h11A2.75 2.75 0 0 0 16.75 13V9.46l5.81 4.15a.79.79 0 0 0 .44.14.77.77 0 0 0 .34-.08.76.76 0 0 0 .41-.67V3a.76.76 0 0 0-.41-.67zM15.25 13c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25V3c0-.69.56-1.25 1.25-1.25h11c.69 0 1.25.56 1.25 1.25v10zm7-1.46l-5-3.54 5-3.54v7.08z',
    fill: color,
    fillRule: 'nonzero',
    transform: 'translate(13 17)'
  }));
};

exports.DefaultVideoThumbnail = DefaultVideoThumbnail;